<section class="create payment">
  <div class="create_title">Pay Fees</div>
  <div cdkFocusInitial class="close-dialog" mat-dialog-close>
    <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
      <path d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
        data-name="Path 7160" fill="#0c2e56" id="Path_7160" transform="translate(-5 -5)" />
    </svg>
  </div>
  <mat-dialog-content>
    <div class="create_content">
      <div class="badge-orange mb-3 w-100" *ngIf="data.update_payment">
        <div class="row">
          <div class="col-sm-12 my-2 committeeDetails_status">
            <div [ngClass]="data.my_payment?.paid_status_class">
              {{ data.my_payment?.paid_status }}
            </div>
          </div>
          <div class="col-sm-12 my-2 committeeDetails_info-createdBy">
            <div class="committeeDetails_info-createdBy title">{{"Payment Methods"|translate}}</div>
            <div class="committeeDetails_info-createdBy content">
              {{ data.my_payment?.payment_options }}
            </div>
          </div>
          <div class="col-sm-12 my-2">
            <div class="committeeDetails_info-createdBy title">{{"Paid on"|translate}}</div>
            <div class="committeeDetails_info-createdBy content">
              {{ data.my_payment?.paid_on | unixDate }}
            </div>
          </div>
          <div class="col-sm-12 my-2" *ngIf="data.my_payment?.account_holder_name">
            <div class="committeeDetails_info-createdBy title">{{"Account Holder Name/Number"|translate}}</div>
            <div class="committeeDetails_info-createdBy content">
              {{ data.my_payment?.account_holder_name }}
            </div>
          </div>
          <div class="col-sm-12 my-2" *ngIf="data.my_payment?.number_of_participants">
            <div class="committeeDetails_info-createdBy title">{{"Number of Participants"|translate}}</div>
            <div class="committeeDetails_info-createdBy content">
              {{ data.my_payment?.number_of_participants }}
            </div>
          </div>
          <div class="col-sm-12 my-2" *ngIf="data.my_payment?.payment_type">
            <div class="committeeDetails_info-createdBy title">{{"Payment Type"|translate}}</div>
            <div class="committeeDetails_info-createdBy content">
              {{data.my_payment?.payment_type == 1 ?('individual'|translate):('Multi'|translate)}}
            </div>
          </div>
          <div class="col-sm-12 my-2">
            <div class="committeeDetails_info-createdBy content">
              <app-files-viewer *ngIf="data?.my_payment?.receipt_file?.name"
                [files]="[data?.my_payment?.receipt_file]"></app-files-viewer>
            </div>
          </div>
        </div>
      </div>
      <div class="payment_paymentDetails">
        <div class="payment_paymentDetails-header">Payment Details</div>
        <div class="payment_paymentDetails-payItem">
          <div class="row">
            <div class="col-sm-6">Training Fees</div>
            <div class="col-sm-6">
              <div class="price">
                <span *ngIf="data.data.tc_type == 0">{{ data.data.course_fees_for_individuals }}</span>
                <span *ngIf="data.data.tc_type == 1">{{ data.data.course_fees_for_group }}</span>
                <span class="currency">{{data.data.currency_symbols}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="payment_paymentDetails mt-3"  *ngIf="data?.data?.trainee_invoice_file">
        <div class="payment_paymentDetails-header">Voucher</div>
        <div class="row">
          <div class="col-12">
            <app-files-viewer [files]="[data?.data?.trainee_invoice_file]"></app-files-viewer>
          </div>
        </div>

      </div>
      <div class="payment_paymentMethods">
        <div class="payment_paymentMethods-header">Payment Methods</div>
        <div class="payment_paymentMethods-subheader">
          You can pay us, by using one of the following methods:
        </div>
        <ng-container *ngFor="let payment of paymentOptions">
          <ng-container *ngIf="payment.option_token == 'ABt4dzdAHfk27ShBNt8gu9CjWp1vzPkKcfc8Qje'">
            <div class="payment_paymentMethods-methods my-2">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center justify-content-between">
                  <div class="method-logo float-none h-auto">
                    <div class="logo dubai">
                      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="46.998" height="55.002"
                          viewBox="0 0 46.998 55.002" class="p-1">
                          <path id="wire-transfer"
                            d="M15.481,55H3.476a1.534,1.534,0,0,1-1.533-1.527V50.488a1.534,1.534,0,0,1,1.533-1.529h1.6v-2.9a1.647,1.647,0,0,1,1.65-1.645h.36V31.2h-.36a1.652,1.652,0,0,1-1.65-1.65v-2.9H3.849a1.9,1.9,0,0,1-1.214-3.363L15.077,13a7.379,7.379,0,0,1-.351-.895H9.78V14a1.35,1.35,0,0,1-2.163,1.074L.53,9.7a1.349,1.349,0,0,1,0-2.145L7.617,2.2A1.348,1.348,0,0,1,9.78,3.266V5.154h5.432a9.236,9.236,0,0,1,16.57,0h5.436V3.266A1.348,1.348,0,0,1,39.381,2.2l7.082,5.363a1.345,1.345,0,0,1,0,2.145l-7.086,5.369A1.348,1.348,0,0,1,37.218,14V12.109H32.271a8.082,8.082,0,0,1-.351.895L44.363,23.293a1.9,1.9,0,0,1-1.214,3.363H41.926v2.9a1.654,1.654,0,0,1-1.65,1.65h-.359V44.418h.359a1.649,1.649,0,0,1,1.65,1.645v2.9h1.6a1.53,1.53,0,0,1,1.529,1.529v2.986A1.53,1.53,0,0,1,43.522,55Zm27.96-1.609V50.574H3.557v2.818H43.441Zm-9.236-8.975h4.1V31.2h-4.1Zm-12.757,0h4.1V31.2h-4.1Zm-12.752,0h4.1V31.2H8.7ZM6.686,29.553a.033.033,0,0,0,.036.035H40.275a.033.033,0,0,0,.036-.035v-2.9H6.686Zm-3.021-5.02a.272.272,0,0,0-.085.32.269.269,0,0,0,.27.193h39.3a.289.289,0,0,0,.185-.514l-12.213-10.1a9.233,9.233,0,0,1-15.243,0ZM15.873,9.227A7.624,7.624,0,1,0,23.5,1.615,7.627,7.627,0,0,0,15.873,9.227Zm6.817,4.951v-.619a4.178,4.178,0,0,1-2.136-1.225.808.808,0,0,1,1.2-1.088,2.613,2.613,0,0,0,1.92.811,1.317,1.317,0,0,0,1.358-.9c.108-.611-.67-.967-1.012-1.092-1.115-.414-2.109-.855-2.149-.873a.719.719,0,0,1-.112-.059,2.2,2.2,0,0,1-.98-2.18,2.462,2.462,0,0,1,1.916-2.016V4.322a.809.809,0,1,1,1.619,0v.584a4.554,4.554,0,0,1,1.817.854A.808.808,0,0,1,25.091,7a2.491,2.491,0,0,0-2.078-.477.814.814,0,0,0-.643.656.592.592,0,0,0,.225.566c.238.1,1.079.467,1.983.8,1.767.652,2.212,1.92,2.037,2.891a2.783,2.783,0,0,1-2.307,2.168v.57a.809.809,0,1,1-1.619,0Z"
                            fill="#fff" />
                        </svg> -->
                      <img src="./assets/images/icons/dmLogo.png" alt="Easy Payment Logo">
                    </div>
                  </div>
                  <div class="method-info">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="header mb-2">{{payment.option_name}}</div>
                      </div>
                      <div class="col-sm-12">
                        <div class="sub-header">
                          You can make payments using the following link:
                          <a class="d-block"
                            href="https://portal.dm.gov.ae/ePayAdhoc/welcomeAdhocCustomer.do?method=launchAdhocHome&locale=1"
                            target="_blank">
                            https://portal.dm.gov.ae/ePayAdhoc/welcomeAdhocCustomer.do?method=launchAdhocHome&locale=1
                          </a>

                          <!-- <span class="currency">
                              {{calculateTotalPayment(payment.calc , paymentData.data.total_fees)|number}}
                              {{paymentData.request_currency}}
                            </span>, once you made a transfer, kindly upload the payment
                            proof here. -->
                        </div>

                        <div class="mt-4">
                          <p>Instructions:</p>

                          <ol type="1">
                            <li> Click “Ad-Hoc Enquiry & Payment”</li>
                            <li> Enter the Voucher Number (e.g., RSLDAC202000401311),<b> this will be sent to you by
                                email</b>
                            </li>
                            <li> Select Voucher Status as ‘Approved’ and click “Search”</li>
                            <li>Check the box for the voucher and click “Pay Selected”</li>
                            <li> Fill in the required details and complete the payment</li>
                            <li> Download the receipt</li>
                            <li> Upload the receipt here to proceed</li>
                          </ol>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="method-details">
                          <!-- <div class="item">
                              <div class="row">
                                <div class="col-sm-4">ACCOUNT NUMBER</div>
                                <div class="col-sm-8 details">
                                  1234567891
                                </div>
                              </div>
                            </div>
                            <div class="item">
                              <div class="row">
                                <div class="col-sm-4">IBAN NUMBER</div>
                                <div class="col-sm-8 details">
                                  1 – 234 – 56789– 1
                                </div>
                              </div>
                            </div>
                            <div class="item">
                              <div class="row">
                                <div class="col-sm-4">SWIFT (BIC) CODE </div>
                                <div class="col-sm-8 details">AAAAAAAAXXX</div>
                              </div>
                            </div>
                            <div class="item">
                              <div class="row">
                                <div class="col-sm-4">ORGANIZATION CODE</div>
                                <div class="col-sm-8 details">12345678</div>
                              </div>
                            </div>
                            <div class="item">
                              <div class="row">
                                <div class="col-sm-4">BENEFICIARY ACCOUNT NAME</div>
                                <div class="col-sm-8 details">
                                  EIAC
                                </div>
                              </div>
                            </div> -->
                          <div class="action-btn">
                            <div class="row">
                              <div class="col-sm-12 question">
                                Have you completed the {{payment.option_name}}?
                              </div>
                              <div class="col-sm-12">
                                <button (click)="onUploadProof(1,payment.option_name)" class="btn customBtn"
                                  mat-raised-button [class.loading]="loading" [disabled]="loading || onlineLoading"
                                  color="primary" mat-dialog-close aria-label="Close">
                                  <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.996" height="18"
                                      viewBox="0 0 18.996 18">
                                      <path id="invoice"
                                        d="M12.113,18a1.976,1.976,0,0,1-1.967-1.963V14.588a.26.26,0,0,0-.078-.2.256.256,0,0,0-.193-.072H2.649L2.726,3.064h7.71a4.748,4.748,0,0,0-.1.947,4.512,4.512,0,0,0,.42,1.914H7.6a.287.287,0,0,0,0,.574h3.47a4.541,4.541,0,0,0,3.007,2.055v7.488A1.962,1.962,0,0,1,12.123,18ZM4.491,11.924A1.009,1.009,0,1,0,5.5,10.953.992.992,0,0,0,4.491,11.924Zm2.823.02a.286.286,0,0,0,.285.285h4.365a.286.286,0,0,0,.285-.285.282.282,0,0,0-.285-.285H7.6A.282.282,0,0,0,7.313,11.943ZM4.491,9.076A1.009,1.009,0,1,0,5.5,8.105.992.992,0,0,0,4.491,9.076Zm2.823,0a.282.282,0,0,0,.285.285h4.365a.282.282,0,0,0,.285-.285.286.286,0,0,0-.285-.285H7.6A.286.286,0,0,0,7.313,9.076ZM4.491,6.234A1.008,1.008,0,1,0,5.5,5.258.989.989,0,0,0,4.491,6.234ZM1.962,18A1.963,1.963,0,0,1,0,16.043V14.887H9.576v1.15a2.515,2.515,0,0,0,.744,1.789,1.637,1.637,0,0,0,.193.174ZM5.07,11.924a.434.434,0,1,1,.431.4A.416.416,0,0,1,5.07,11.924Zm0-2.848a.434.434,0,1,1,.431.4A.42.42,0,0,1,5.07,9.076Zm5.858-5.045a4.034,4.034,0,1,1,4.036,4.035A4.036,4.036,0,0,1,10.929,4.031ZM13.6,5.09a1.345,1.345,0,0,0,1.024,1.3v.391a.288.288,0,0,0,.575,0V6.408a1.343,1.343,0,0,0-.256-2.662A.773.773,0,0,1,14.888,2.2h.029a.162.162,0,0,0,.043,0,.775.775,0,0,1,.759.773.285.285,0,0,0,.57,0A1.343,1.343,0,0,0,15.2,1.652V1.3a.288.288,0,1,0-.575,0v.357a1.347,1.347,0,0,0,.319,2.654.773.773,0,1,1-.773.773.285.285,0,0,0-.57,0ZM5.07,6.234a.434.434,0,1,1,.431.4A.416.416,0,0,1,5.07,6.234Z"
                                        fill="#fff" />
                                    </svg>
                                    Upload Proof</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="payment.option_token == 'HAG43234dAHHrtrBNt8gu9CjWp1vzPkK434xvSJ' && !data.data.is_coordinator">
            <div class="payment_paymentMethods-methods my-2">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <div class="method-logo float-none h-auto">
                    <div>
                      <!-- <img src="./assets/images/egac-white.png" alt="egac" class="p-1"/> -->
                      <img alt="EIAC" class="w-100" src="assets/images/eiac_logo.png" />
                    </div>
                  </div>
                  <div class="method-info">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="header">{{"training.Direct payment confirmation"|translate}}</div>
                      </div>
                      <div class="col-sm-12">
                        <div class="sub-header">
                          <!-- {{"traningDetails.You can pay by visiting us at the head office and pay with Cash."|translate}} -->
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="method-details">
                          <div class="action-btn">
                            <div class="row">
                              <div class="col-sm-12">
                                <button [class.loading]="loading" [disabled]="loading" class="btn customBtn"
                                  color="primary" (click)="DirectlyConfirmPayment(5)" mat-raised-button>
                                  <span> {{"training.Confirm Payment"|translate}} </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Dubai Pay -->
          <ng-container *ngIf="payment.option_token == 'ABtdzdAHHrtrBNt8gu9CjWp1vzPkKcfc8Qje'">
            <div class="payment_paymentMethods-methods my-2">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center justify-content-between">
                  <div class="method-logo float-none h-auto">
                    <div class="logo dubai">
                      <img src="/assets/images/dubai-pay-logo.png" alt="">
                    </div>
                  </div>
                  <div class="method-info">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="header">Dubi Pay</div>
                      </div>
                      <div class="col-sm-12">
                        <div class="sub-header">
                          Pay the required amount easily through Dubi Pay (Commission will be added)
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="method-details">
                          <div class="action-btn">
                            <div class="row">
                              <div class="col-sm-12">
                                <!-- disabled -->
                                <button (click)="onlinePay()" class="btn btn-dubai" mat-raised-button
                                  [class.loading]="onlineLoading" [disabled]="onlineLoading">
                                  <span> Pay With Dubi Pay </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm-12 mt-4" *ngIf="payment.option_values?.length">
                    <div class="payment_paymentDetails">
                      <div class="payment_paymentDetails-header">Extra Payment</div>
                      <div class="payment_paymentDetails-payItem" *ngFor="let item of payment.option_values">
                        <div class="row">
                          <div class="col-sm-6">
                            {{item.name_en}}
                            <ng-container *ngIf="item.deduction_method == '2'">
                              ({{item.value}})
                            </ng-container>
                          </div>
                          <div class="col-sm-6">
                            <div class="price">
                              {{item.calc}}
                              <span class="currency">{{paymentData.request_currency}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div class="payment_paymentDetails-total">
                        <div class="row">
                          <div class="col-sm-6">Total Extra Fees</div>
                          <div class="col-sm-6">
                            <div class="price">
                              {{payment.calc}}
                              <span class="currency">{{paymentData.request_currency}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div class="payment_paymentDetails-total">
                        <div class="row">
                          <div class="col-sm-6">Total Fees</div>
                          <div class="col-sm-6">
                            <div class="price">
                              {{payment.calc + paymentData.data.total_fees}}
                              <span class="currency">{{paymentData.request_currency}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                <!-- <ng-container
                      [ngTemplateOutlet]='paymentList'
                      [ngTemplateOutletContext]='{payment: payment}'>
                  </ng-container> -->
              </div>
            </div>
          </ng-container>

          <!-- Al Ansari Exchange -->
          <ng-container *ngIf="payment.option_token == 'ABt4dzdAHfk27ShBNt8gu9CjWpVBCBNyy1'">
            <div class="payment_paymentMethods-methods my-2">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center justify-content-between">
                  <div class="method-logo float-none h-auto">
                    <div class="logo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="46.998" height="55.002" viewBox="0 0 46.998 55.002"
                        class="p-1">
                        <path id="wire-transfer"
                          d="M15.481,55H3.476a1.534,1.534,0,0,1-1.533-1.527V50.488a1.534,1.534,0,0,1,1.533-1.529h1.6v-2.9a1.647,1.647,0,0,1,1.65-1.645h.36V31.2h-.36a1.652,1.652,0,0,1-1.65-1.65v-2.9H3.849a1.9,1.9,0,0,1-1.214-3.363L15.077,13a7.379,7.379,0,0,1-.351-.895H9.78V14a1.35,1.35,0,0,1-2.163,1.074L.53,9.7a1.349,1.349,0,0,1,0-2.145L7.617,2.2A1.348,1.348,0,0,1,9.78,3.266V5.154h5.432a9.236,9.236,0,0,1,16.57,0h5.436V3.266A1.348,1.348,0,0,1,39.381,2.2l7.082,5.363a1.345,1.345,0,0,1,0,2.145l-7.086,5.369A1.348,1.348,0,0,1,37.218,14V12.109H32.271a8.082,8.082,0,0,1-.351.895L44.363,23.293a1.9,1.9,0,0,1-1.214,3.363H41.926v2.9a1.654,1.654,0,0,1-1.65,1.65h-.359V44.418h.359a1.649,1.649,0,0,1,1.65,1.645v2.9h1.6a1.53,1.53,0,0,1,1.529,1.529v2.986A1.53,1.53,0,0,1,43.522,55Zm27.96-1.609V50.574H3.557v2.818H43.441Zm-9.236-8.975h4.1V31.2h-4.1Zm-12.757,0h4.1V31.2h-4.1Zm-12.752,0h4.1V31.2H8.7ZM6.686,29.553a.033.033,0,0,0,.036.035H40.275a.033.033,0,0,0,.036-.035v-2.9H6.686Zm-3.021-5.02a.272.272,0,0,0-.085.32.269.269,0,0,0,.27.193h39.3a.289.289,0,0,0,.185-.514l-12.213-10.1a9.233,9.233,0,0,1-15.243,0ZM15.873,9.227A7.624,7.624,0,1,0,23.5,1.615,7.627,7.627,0,0,0,15.873,9.227Zm6.817,4.951v-.619a4.178,4.178,0,0,1-2.136-1.225.808.808,0,0,1,1.2-1.088,2.613,2.613,0,0,0,1.92.811,1.317,1.317,0,0,0,1.358-.9c.108-.611-.67-.967-1.012-1.092-1.115-.414-2.109-.855-2.149-.873a.719.719,0,0,1-.112-.059,2.2,2.2,0,0,1-.98-2.18,2.462,2.462,0,0,1,1.916-2.016V4.322a.809.809,0,1,1,1.619,0v.584a4.554,4.554,0,0,1,1.817.854A.808.808,0,0,1,25.091,7a2.491,2.491,0,0,0-2.078-.477.814.814,0,0,0-.643.656.592.592,0,0,0,.225.566c.238.1,1.079.467,1.983.8,1.767.652,2.212,1.92,2.037,2.891a2.783,2.783,0,0,1-2.307,2.168v.57a.809.809,0,1,1-1.619,0Z"
                          fill="#fff" />
                      </svg>
                      <!-- <img src="./assets/images/icons/dmLogo.png" alt="Easy Payment Logo"> -->
                    </div>
                  </div>
                  <div class="method-info">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="header mb-2">{{payment.option_name}}</div>
                      </div>
                      <div class="col-sm-12">
                        <div class="sub-header">
                          Al Ansari Exchange - Offline Payment (Cash / Credit Card / Cheque)
                        </div>

                        <div class="mt-3">
                          <p>
                            You may also make payments at any Al Ansari Exchange branch across the UAE, as follows:
                          </p>

                          <p>

                            Payee: Al Ansari Exchange L.L.C
                            Note: Transfer charges must be included in the payment.
                            Requirement: A copy of the payment receipt must be uploaded here to proceed.

                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="method-details">
                          <div class="action-btn">
                            <div class="row">
                              <div class="col-sm-12 question">
                                Have you completed the {{payment.option_name}}?
                              </div>
                              <div class="col-sm-12">
                                <button (click)="onUploadProof(4,payment.option_name)" class="btn customBtn"
                                  mat-raised-button [class.loading]="loading" [disabled]="loading || onlineLoading"
                                  color="primary" mat-dialog-close aria-label="Close">
                                  <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.996" height="18"
                                      viewBox="0 0 18.996 18">
                                      <path id="invoice"
                                        d="M12.113,18a1.976,1.976,0,0,1-1.967-1.963V14.588a.26.26,0,0,0-.078-.2.256.256,0,0,0-.193-.072H2.649L2.726,3.064h7.71a4.748,4.748,0,0,0-.1.947,4.512,4.512,0,0,0,.42,1.914H7.6a.287.287,0,0,0,0,.574h3.47a4.541,4.541,0,0,0,3.007,2.055v7.488A1.962,1.962,0,0,1,12.123,18ZM4.491,11.924A1.009,1.009,0,1,0,5.5,10.953.992.992,0,0,0,4.491,11.924Zm2.823.02a.286.286,0,0,0,.285.285h4.365a.286.286,0,0,0,.285-.285.282.282,0,0,0-.285-.285H7.6A.282.282,0,0,0,7.313,11.943ZM4.491,9.076A1.009,1.009,0,1,0,5.5,8.105.992.992,0,0,0,4.491,9.076Zm2.823,0a.282.282,0,0,0,.285.285h4.365a.282.282,0,0,0,.285-.285.286.286,0,0,0-.285-.285H7.6A.286.286,0,0,0,7.313,9.076ZM4.491,6.234A1.008,1.008,0,1,0,5.5,5.258.989.989,0,0,0,4.491,6.234ZM1.962,18A1.963,1.963,0,0,1,0,16.043V14.887H9.576v1.15a2.515,2.515,0,0,0,.744,1.789,1.637,1.637,0,0,0,.193.174ZM5.07,11.924a.434.434,0,1,1,.431.4A.416.416,0,0,1,5.07,11.924Zm0-2.848a.434.434,0,1,1,.431.4A.42.42,0,0,1,5.07,9.076Zm5.858-5.045a4.034,4.034,0,1,1,4.036,4.035A4.036,4.036,0,0,1,10.929,4.031ZM13.6,5.09a1.345,1.345,0,0,0,1.024,1.3v.391a.288.288,0,0,0,.575,0V6.408a1.343,1.343,0,0,0-.256-2.662A.773.773,0,0,1,14.888,2.2h.029a.162.162,0,0,0,.043,0,.775.775,0,0,1,.759.773.285.285,0,0,0,.57,0A1.343,1.343,0,0,0,15.2,1.652V1.3a.288.288,0,1,0-.575,0v.357a1.347,1.347,0,0,0,.319,2.654.773.773,0,1,1-.773.773.285.285,0,0,0-.57,0ZM5.07,6.234a.434.434,0,1,1,.431.4A.416.416,0,0,1,5.07,6.234Z"
                                        fill="#fff" />
                                    </svg>
                                    Upload Proof</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <ng-container [ngTemplateOutlet]='paymentList' [ngTemplateOutletContext]='{payment: payment}'>
                </ng-container> -->
              </div>
            </div>
          </ng-container>
          <!-- <ng-container *ngIf="payment.option_token == 'ABtdzdAHH8k27ShBNt8gu9CjWp1vzPkKcfc8Qje'">
            <div class="payment_paymentMethods-methods my-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="method-logo">
                    <div class="logo">
                      <img alt="EIAC" src="./assets/images/eiac-white.png" />
                    </div>
                  </div>
                  <div class="method-info">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="header">Pay at EIAC Office</div>
                      </div>
                      <div class="col-sm-12">
                        <div class="sub-header">
                          You can pay by visiting us at the head office and pay with
                          your Debit / Credit Card.
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="method-details">
                          <div class="action-btn">
                            <div class="row">
                              <div class="col-sm-12">
                                <button [class.loading]="loading" [disabled]="loading" class="btn customBtn"
                                  color="primary" (click)="onOfficePay()" mat-raised-button>
                                  <span> Pay </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container> -->


        </ng-container>


      </div>
    </div>
    <form class="d-none" id="redirectToPay" ngNoForm [action]="payment_gateway_url" method="post">
      <input name="SenderID" [(ngModel)]="SenderID" [value]="SenderID">
      <input name="RandomSecret" [(ngModel)]="RandomSecret" [value]="RandomSecret">
      <input name="RequestObject" [(ngModel)]="RequestObject" [value]="RequestObject">
      <input name="HasedRequestObject" [(ngModel)]="HasedRequestObject" [value]="HasedRequestObject">
      <button type="submit" value="submit"></button>
    </form>
  </mat-dialog-content>
</section>